module.exports = __webpack_public_path__ + "static/robert-568863e618cdfaa8f7af100229b54ee5.mp3";